import React from "react";
import "./styles.css";

interface SelectNacionalidadeProps {
  setNacionalidade?: React.Dispatch<React.SetStateAction<string>>;
  Nacionalidade?: string;
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
}

const COUNTRY_CODES = (
  "AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ " +
  "CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR " +
  "GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO " +
  "JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR " +
  "MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO " +
  "RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW " +
  "TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW"
).split(" ");

const nomesRegioes = new Intl.DisplayNames(["pt-BR"], { type: "region" });

const paises = COUNTRY_CODES
  .map((codigo) => ({ codigo, nome: nomesRegioes.of(codigo) ?? codigo }))
  .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

export const SelectNacionalidade = ({
  setNacionalidade,
  Nacionalidade,
  onChange,
}: SelectNacionalidadeProps) => (
  <select
    className="custom-select select-menor"
    required
    value={Nacionalidade}
    onChange={(event) =>
      onChange ? onChange(event) : setNacionalidade?.(event.target.value)
    }
  >
    <option value="" disabled>
      País de nascimento
    </option>
    {paises.map(({ codigo, nome }) => (
      <option className="Pais" value={codigo} key={codigo}>
        {nome}
      </option>
    ))}
  </select>
);
